import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconShare: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width ?? 24}
      height={height ?? 24}
      fill="none"
      stroke={color ?? "#475569"}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <path d="m8.59 13.51l6.83 3.98m-.01-10.98l-6.82 3.98" />
    </svg>
  );
};
